import { useEffect, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { CommonMenu, Sidemenu, Breadcrumbs } from '.';
import cx from 'classnames';
import { useContext } from 'react';
import { FilterContext } from '../contexts';
import _ from 'lodash';
import { icons } from '../assets';
import { selectSearchActive, selectSearchOpenFrom } from '../redux/slicers/search/searchSlicer';
import { useSelector } from 'react-redux';
import SearchResult from '../components/container/SearchResult';
import { Loader } from '../common';
import { useUserContext } from '../contexts/UserContext';
import { VerifyYourEmail } from '../common/VerifyYourEmail';
import { refreshHubspotChatbot } from '../hooks/useHubspotChatbotPopup';
import FreeTrialCongratsPopup from '../common/FreeTrial/FreeTrialCongratsPopup';
import FreeTrialExpiredPopup from '../common/FreeTrial/FreeTrialExpiredPopup';

// common layout for screens with logged into a session
export default function LayoutWrapper({
  nav = true,
  sidenav = true,
  token,
  refreshToken,
  currentUser,
  fullScreen,
}) {
  const userCtx = useUserContext();
  const searchActive = useSelector(selectSearchActive);
  const calculatedFullScreen = fullScreen && !searchActive;

  const filterCtx = useContext(FilterContext);
  const pageWrapper = useRef();
  const visualViewportHeight = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;
  const heightMinusHeader = visualViewportHeight - 64;
  const [contentHeight, setContentHeight] = useState(heightMinusHeader);
  const [showMenu, setShowMenu] = useState(false);

  // Refreshing the HubSpot chatbot when the user reloads the page or navigates from the curator page.
  useEffect(() => refreshHubspotChatbot({ time: 0 }), []);

  useEffect(() => {
    if (pageWrapper && pageWrapper.current && token) {
      const newHeight = _.ceil(pageWrapper.current.offsetHeight, contentHeight, heightMinusHeader);
      if (newHeight > contentHeight) {
        setContentHeight(newHeight);
      }
    }
  }, [pageWrapper, contentHeight, heightMinusHeader, token]);

  if (!token || !refreshToken || !currentUser) return <Outlet />; // token here

  const sidebarActive = sidenav || searchActive;

  return (
    <div>
      {userCtx.logoutLoading && <Loader loading backdrop={true} />}
      <FreeTrialCongratsPopup />
      <FreeTrialExpiredPopup />
      {nav && <CommonMenu setShowMenu={setShowMenu} showMenu={showMenu} />}
      <section className="body-of-main">
        {sidebarActive && <Sidemenu height={`${contentHeight}px`} showMenu={showMenu} />}
        <Container
          fluid
          className={cx(
            {
              'page-wrapper': !calculatedFullScreen,
              'full-screeen-page-wrapper': calculatedFullScreen,
            },
            'p-0',
            !sidebarActive && 'no-sidebar'
          )}
          ref={pageWrapper}>
          {filterCtx && filterCtx.breadcrumbs && <Breadcrumbs list={filterCtx.breadcrumbs} />}
          {searchActive && nav ? <SearchResult /> : <Outlet />}
        </Container>
        <VerifyYourEmail {...(!sidebarActive && { fullWidth: true })} />
      </section>
    </div>
  );
}
